<template>
    <div class="page">
        <box fill>
            <el-form label-position="right" label-width="80px" class="EL-Form EL-foemFlex">
                <el-row style="width: 50%">
                    <el-col :lg="10" :xl="10">
                        <el-form-item label="库位编号" class="EL-Form-Item">
                            <el-input placeholder="请输入" v-model="pagination.lcCode" @change="saveSearch()">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="10" :xl="10">
                        <el-form-item label="物料编号" class="EL-Form-Item">
                            <el-input placeholder="请输入" v-model="pagination.matCode" @change="saveSearch()">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="4" :xl="4">
                        <el-form-item class="btn-edit-delete EL-Form-Item">
                            <el-button class="btn-t-edit" @click="getAuxiMaterialData()">
                                查询
                            </el-button>
                            <!-- <el-button class="btn-t-delete" @click="resetData()">
                            重置
                        </el-button> -->
                        </el-form-item>
                    </el-col>
                    <el-col :lg="10" :xl="10">
                        <el-form-item label="物料描述" class="EL-Form-Item">
                            <el-input placeholder="请输入" v-model="pagination.matName" @change="saveSearch()">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="10" :xl="10">
                        <el-form-item label="批号" class="EL-Form-Item">
                            <el-input placeholder="请输入" v-model="pagination.batchNo" @change="saveSearch()">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="4" :xl="4">
                        <el-form-item class="btn-edit-delete EL-Form-Item">
                            <!-- <el-button class="btn-t-edit" @click="getAuxiMaterialData()">
                            查询
                        </el-button> -->
                            <el-button class="btn-t-delete" @click="resetData()">
                                重置
                            </el-button>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="10" :xl="10">
                        <el-form-item label="开始日期" class="EL-Form-Item">
                            <el-date-picker v-model="pagination.requireDate[0]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="开始日期" :picker-options="pickerOptions0"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="10" :xl="10">
                        <el-form-item label="结束日期" class="EL-Form-Item">
                            <el-date-picker v-model="pagination.requireDate[1]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="结束日期" :picker-options="pickerOptions"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="10" :xl="10">
                        <el-form-item label="库龄" class="EL-Form-Item">
                            <el-select v-model="pagination.type"  @change="saveSearch()">
                                <el-option key="1" value="1" label="三个月内"></el-option>
                                <el-option key="2" value="2" label="半年内"></el-option>
                                <el-option key="3" value="3" label="一年内"></el-option>
                                <el-option key="4" value="4" label="三年内"></el-option>
                                <el-option key="5" value="5" label="三年以上"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <!-- <el-col :lg="24" :xl="24" class="red">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="getAuxiMaterialData()">
                            查询
                        </el-button>
                        <el-button class="btn-t-delete" @click="resetData()">
                            重置
                        </el-button>
                    </el-form-item>
                </el-col> -->
                </el-row>
                <el-row style="width: 50%">
                    <el-col :lg="24" :xl="24">
                        <div class="echarts-box" ref="echarts"></div>
                    </el-col>
                </el-row>
            </el-form>
            <el-divider></el-divider>
            <plabel text="库龄分析报表">
                <el-button v-authority="'BACK_MENU7_M8_B1'" :loading="downloadLoading" class="btn-t-edit" type="primary" @click="downLoadFile()">导出EXCEL</el-button>
            </plabel>
            <!-- 展示 -->
            <h-table :headerCellStyle="headerCellStyle" style="flex: 1" @pageChange="getAuxiMaterialData" :data="mainData" pagination :nowPage.sync="pagination.pageNum" :pageSize.sync="pagination.pageSize" :total.sync="pagination.total">
                <el-table-column prop="whCode" label="仓库" />
                <el-table-column prop="lcCode" label="库位编号" />
                <el-table-column prop="matCode" label="物料编号" />
                <el-table-column prop="matName" label="物料描述" />
                <el-table-column prop="batchNo" label="批号" />
                <el-table-column prop="boxBarcode" label="包装编号" />
                <el-table-column prop="verdorCode" label="供应商" />
                <el-table-column prop="matQuan" label="数量" />
                <!-- <el-table-column prop="checkFlag" label="是否质检">
                    <template slot-scope="scope">
                        <div v-if="scope.row.checkFlag == false">否</div>
                        <div v-if="scope.row.checkFlag == true">是</div>
                    </template>
                </el-table-column> -->
                <el-table-column prop="matCreateTime" label="入库日期" />
                <el-table-column prop="inventoryAge" label="库龄">
                    <template slot-scope="scope">
                        <div v-if="scope.row.inventoryAge > 0 && scope.row.inventoryAge <= 90">三个月内</div>
                        <div v-if="scope.row.inventoryAge > 90 && scope.row.inventoryAge <= 180">半年内</div>
                        <div v-if="scope.row.inventoryAge > 180 && scope.row.inventoryAge <= 365">一年内</div>
                        <div v-if="scope.row.inventoryAge > 365 && scope.row.inventoryAge <= 1095">三年内</div>
                        <div v-if="scope.row.inventoryAge > 1095">三年以上</div>
                    </template>
                </el-table-column>
            </h-table>
        </box>
    </div>
</template>

<script>
    import * as echarts from "echarts"; // 导图全局 echarts
    export default {
        name: "InventoryAge",
        data() {
            return {
                headerCellStyle: () => {
                    return "background-color: #1f5cec";
                },
                form: {},
                //主数据
                mainData: [],
                pagination: {
                    pageNum: 1,
                    pageSize: 50,
                    total: 0,
                    matCode: "",
                    lcCode: "",
                    batchNo: "",
                    matName: "",
                    fcCode: localStorage.getItem("fcCode") || "",
                    requireDate: [],
                    type: ''
                },
                taskTab: "0",

                downloadLoading: false, //下载中

                logContent: "", //操作日志-内容
                logRemarks: "", //操作日志-备注
                // 输入框延时加载
                isSetTimeout: null,
            };
        },
        watch: {
            pagination: {
                handler(newVal) {
                    clearTimeout(this.isSetTimeout)
                    this.isSetTimeout = setTimeout(() => {
                        this.getAuxiMaterialData(newVal);
                    },1000)
                },
                deep: true,
            },
        },
        computed: {
            pickerOptions() {
                let _this = this;
                return {
                    disabledDate(time) {
                        if (_this.pagination.requireDate[0]) {
                            return time.getTime() < new Date(_this.pagination.requireDate[0]);
                        }
                    },
                };
            },
            pickerOptions0() {
                let _this = this;
                return {
                    disabledDate(time) {
                        if (_this.pagination.requireDate[1]) {
                            return time.getTime() > new Date(_this.pagination.requireDate[1]);
                        }
                    },
                };
            },
        },
        methods: {
			setPieChart(data) {
				this.$nextTick(() => {
					var myChart = echarts.init(this.$refs.echarts);
					var optionChart = {
						// title: {
						//   text: "",
						//   left: "left",
						// },
						tooltip: {
							trigger: "item",
							formatter: "{a} <br/>{b} : {c} ({d}%)",
						},
						legend: {
							orient: "vertical",
							left: "right",
							type: "scroll",
							right: 10,
							top: 20,
							bottom: 20,
						},
						series: [{
							name: "库龄",
							type: "pie",
							radius: "55%",
							center: ["40%", "50%"],
							data: data,
							emphasis: {
								itemStyle: {
									shadowBlur: 10,
									shadowOffsetX: 0,
									shadowColor: "rgba(0, 0, 0, 0.5)",
								},
							},
						}],
					};
					myChart.setOption(optionChart);
      			});
			},
            // 节流搜索
            saveSearch() {
                if (window.lazy) window.clearTimeout(window.lazy);
                window.lazy = window.setTimeout(() => {
                    this.getAuxiMaterialData();
                }, 1000);
            },
            //获取数据
            getAuxiMaterialData() {
                this.$http
                    .request({
                        url: "/api/inventory/getInventoryAgeData",
                        method: "GET",
                        params: {
                            pageNum: this.pagination.pageNum,
                            pageSize: this.pagination.pageSize,
                            matCode: this.pagination.matCode,
                            lcCode: this.pagination.lcCode,
                            batchNo: this.pagination.batchNo,
                            matName: this.pagination.matName,
                            fcCode: this.pagination.fcCode,
                            beginTime: this.pagination.requireDate[0] || null,
                            endTime: this.pagination.requireDate[1] || null,
                            type: this.pagination.type,
                        },
                    })
                    .then((resp) => {
                        this.loading--;
                        if (resp.status == 100) {
                            this.mainData = resp.data.list || [];
                            this.pagination.total = resp.data.total;
                        }
                    })
                    .catch((error) => {
                        this.loading--;
                    });
            },
			getInventoryAgeDataPie() {
				this.$http.request({
					url: "/api/inventory/getInventoryAgeDataPie",
					method: "GET",
					params: {
            fcCode: this.pagination.fcCode,
					},
				}).then((resp) => {
					if (resp.status == 100) {
						this.setPieChart(resp.data);
					}
				}).catch((error) => {});
    		},
            //重置
            resetData() {
                this.pagination = {
                    pageNum: 1,
                    pageSize: 50,
                    total: 0,
                    matCode: "",
                    lcCode: "",
                    batchNo: "",
                    matName: "",
                    fcCode: localStorage.getItem("fcCode") || "",
                    requireDate: [],
                };
                this.getAuxiMaterialData();
            },

            //表格导出
            downLoadFile() {
                this.downloadLoading = true;
                var paramsObj = {
                    matCode: this.pagination.matCode,
                    lcCode: this.pagination.lcCode,
                    batchNo: this.pagination.batchNo,
                    matName: this.pagination.matName,
                    fcCode: this.pagination.fcCode,
                    beginTime: this.pagination.requireDate[0] || null,
                    endTime: this.pagination.requireDate[1] || null,
                    pageNum: 1,
                    pageSize: 999999,
                    type: this.pagination.type
                };

                this.$http
                    .request({
                        url: "/api/inventory/getInventoryAgeData",
                        method: "GET",
                        params: paramsObj,
                    })
                    .then((resp) => {
                        resp.status == 100 ?
                            this.downLoad(resp.data.list || []) :
                            this.$notify.error({
                                message: "查询失败",
                            });
                    });
            },
            downLoad(list) {
                import("@/libs/Export2Excel").then((excel) => {
                    list.forEach(function(c) {
                        if (c.checkFlag == true) {
                            c["checkFlag"] = "是";
                        } else if (c.checkFlag == false) {
                            c["checkFlag"] = "否";
                        }

                        if(c.inventoryAge >=0 && c.inventoryAge <= 90){
                            c.inventoryAge = "三个月内"
                        }else if(c.inventoryAge =90 && c.inventoryAge <= 180){
                            c.inventoryAge = "半年内"
                        }else if(c.inventoryAge =180 && c.inventoryAge <= 365){
                            c.inventoryAge = "一年内"
                        }else if(c.inventoryAge =365 && c.inventoryAge <= 1095){
                            c.inventoryAge = "三年内"
                        }else if(c.inventoryAge >1095){
                            c.inventoryAge = "三年以上"
                        }
                    });
                    const tHeader = [
                        "仓库",
                        "库位编号",
                        "物料编号",
                        "物料描述",
                        "批号",
                        "包装编号",
                        "供应商",
                        "入库日期",
                        "库龄",
                    ];
                    const filterVal = [
                        "whCode",
                        "lcCode",
                        "matCode",
                        "matName",
                        "batchNo",
                        "boxBarcode",
                        "verdorCode",
                        "matCreateTime",
                        "inventoryAge",
                    ];
                    const data = this.formatJson(filterVal, list);
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: "库龄分析报表数据",
                    });
                    this.logContent = "导出";
                    this.logRemarks = "wh_inventory：导出库龄分析报表数据";
                    this.systemLog();
                    this.downloadLoading = false;
                });
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map((v) => filterVal.map((j) => v[j]));
            },

            /**
             * 操作日志
             */
            systemLog() {
                let objData = {
                    logType: "库龄分析报表",
                    logContent: this.logRemarks || "",
                    //logRemarks: this.logRemarks || "",
                    logUser: localStorage.getItem("user") || "",
                };
                this.$http
                    .request({
                        url: "api/log/insert",
                        method: "POST",
                        data: objData,
                    })
                    .then((resp) => {
                        this.logContent = "";
                        this.logRemarks = "";
                        if (resp.status == 100) {}
                    })
                    .catch((error) => {});
            },
        },
        mounted() {},
        activated(){
            /* 获取首页的数据 */
            this.getAuxiMaterialData();
			this.getInventoryAgeDataPie();
        },
    };
</script>

<style scoped>
    .EL-foemFlex {
        display: flex;
    }

    .echarts-box {
        min-height: 200px;
    }
</style>